
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 1)","stroke":"#fff","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"x":".5","y":"3.5","width":"13","height":"15","rx":"2"}}),_c('path',{attrs:{"d":"M2.5 5.5h9v2h-9zM2.5 7.5h9v2h-9zM2.5 11.5h9v2h-9zM2.5 13.5h9v2h-9z"}}),_c('path',{attrs:{"d":"M5.5 5.5v10M8.5 5.5v10","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M2.5 9.5h9v2h-9z"}}),_c('path',{attrs:{"d":"M12.61 10.933c0 .346.422.523.677.284l5.604-5.27a.388.388 0 000-.567L13.287.11c-.255-.24-.678-.062-.678.284v2.882a9.817 9.817 0 00-1.737.09 9.518 9.518 0 00-3.114.977C5.487 5.53 3.818 7.64 3.013 10.84c-.107.426.471.678.721.313l.023-.032.085-.11c.1-.123.22-.261.364-.411A9.06 9.06 0 015.75 9.327c1.442-.951 3.207-1.598 5.31-1.799.703-.05 1.153-.048 1.55.02v3.385z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    